// @ts-nocheck
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import constants from "@store/constants";
import OrderHeader, { OrderHeaderStyles } from "@store/Library/Components/Toolkit/Order/OrderHeader";
import useQueryString from "@toolkit/Framework/Common/Hooks/useQueryString";
import { useWishListState } from "@toolkit/Framework/Store/Data/MyLists/MyListsHooks";
import { useCurrentPage } from "@toolkit/Framework/Store/Data/Pages/PageHooks";
import { usePageLinkByPageType } from "@toolkit/Framework/Store/Links/LinksHooks";
import React, { FC } from "react";

type Props = WidgetProps;

export interface MyListsDetailsHeaderActionsStyles {
    orderHeader?: OrderHeaderStyles;
}

export const myListsDetailsHeaderActionsStyles: MyListsDetailsHeaderActionsStyles = {};

const styles = myListsDetailsHeaderActionsStyles;

const MyListsDetailsHeaderActions: FC<Props> = (props: Props) => {
    const linkBack = usePageLinkByPageType(constants.pageType.myLists);
    const currentPage = useCurrentPage();
    const { id } = useQueryString();
    const { value: wishList } = useWishListState(id);

    return (
        <OrderHeader
            title={wishList ? wishList.name : currentPage.fields.title}
            linkBack={linkBack}
            extendedStyles={styles.orderHeader}
        >
            <Zone contentId={props.id} zoneName="ActionButtons" />
        </OrderHeader>
    );
};

const widgetModule: WidgetModule = {
    component: MyListsDetailsHeaderActions,
    definition: {
        group: "My Lists Details",
        displayName: "Header",
        allowedContexts: ["MyListsDetailsPage"],
    },
};

export default widgetModule;
